import React, { useState } from 'react'

const Temp8 = ({ selectedColor, onPathClick, selectedStroke }) => {
  const [isClicked, setIsClicked] = useState(new Array(35).fill(false));

  const handleClick = (event, index) => {
    onPathClick(event);


    setIsClicked((prevIsClicked) =>
      prevIsClicked.map((clicked, i) => (i === index ? !clicked : clicked))
    );
  };

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 394.51 1117.78">
      <defs>
        <style>
          {
            `
 .cls-1{isolation:isolate;}
 .cls-10,.cls-2,.cls-5{
 stroke: ${selectedStroke} ;stroke-miterlimit:10;
 }
 .cls-2{stroke-width:2px;}
 .cls-5{stroke-width:1px;}
 .cls-14,.cls-7,.cls-8{mix-blend-mode:multiply;}
 .cls-7{opacity:0.35;}
 .cls-14,.cls-8{opacity:0.5;}
 .cls-13{fill:url(#linear-gradient);}
  `
          }

        </style>

        
        <linearGradient id="linear-gradient" x1="432.29" y1="524.82" x2="432.29" y2="527.74" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#fec130" />
          <stop offset="1" stop-color="#fbaa30" />
        </linearGradient>
      </defs>
      <g className="cls-1">
        <g id="Layer_1" data-name="Layer 1">
          <path className="cls-2" d="M692.48,957.48c-1.42,12.81-28.1,21.47-30.57,22.88-1.11.63-4.06-10.34-7-22.64-4.4,1.63-9.77,2-12.87,1.1-5.43-1.59,3.17-25.36,5.89-32.56.12-.31.22-.58.32-.82h1.28l-.81-1.23-.47,1.23h-.49s-43.45-103.9-54.94-189c1.39-8.15,3.54-20.37,5.8-33.6,13.85-33.36,27.85-68.77,29.08-80.77,2.49-24.3-23.06-66.66-27.42-84.74C596.35,521,591.4,503,564.77,492.58c2.08.51,65.58,5.59,79.85,59.45,6.51,24.58-17.25,182.5-17.25,182.5l37.79,190.91S693.91,944.67,692.48,957.48Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[0] ? selectedColor : 'white'}
          />
          <path className="cls-3 grp" d="M429.05,332.59c.06-1.87-7.41-20,2.1-28.21s9.61-3.67,15.26-15.27,3.78-10.84,19.21-11.41,10.44-15.3,26.6-20.62,18.78.53,29,3.65S540,249.22,557.1,252.9s7.28,22.25,19.57,31.59,41.26,4.81,35.09,27.82,10.58,58.3,7.55,66.06-8.51,12.71-9.76,16.44,9.52,20.19,6.91,24.57-20.88,28.44-28.71,29.85S579.5,460.82,567.83,467s-31.62,15.56-41,16.41-10.58.56-27.93-2.83-28,1.7-35.39-6.51,2.13-8.43-11.8-18.67-22.44-4.24-22.2-18.95,6-10.18-3.05-22.35-15-3.56-11-25.4,8.31-30,6.89-38.53.95-11.88,3.09-13.86S428.85,338.46,429.05,332.59Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[1] ? selectedColor : 'gray'}
          />
          <path className="cls-4" d="M650.27,926.75H649l.47-1.23Z" transform="translate(-346.38 -252.3)"
          //nothing yet

          />
          <path className="cls-5" d="M488.12,1365.1s-23.79-149.48-36.87-173.77-27.66-126.54-40.62-178.94-11.8-113.51-11.8-113.51l95.82-6.64,9.05,472.86Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[2] ? selectedColor : 'white'}
          />
          <path className="cls-6" d="M514.36,1368.39l-19.5-21.88s-17.29,14.66-24.66,21.88Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[3] ? selectedColor : 'black'}
          />
          <path className="cls-5" d="M599,877.85c2.2,8.11,129.17,490.08,129.17,490.08H715.42s-10.23-42.11-26.84-70.23-104.22-137.13-93.31-184.8-15.72-195.1-52.6-220.66C542.7,868,599,877.85,599,877.85Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[4] ? selectedColor : 'white'}
          />
          <path className="cls-7" d="M631.29,999.47c-14-1.45-28.95-2.91-44.22-4.35,9.77,45.76,13.62,94.09,8.2,117.78a45,45,0,0,0-.65,14.36c28.26,6,54.38,11,74.26,14C655.93,1092.42,642.71,1042.52,631.29,999.47Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[5] ? selectedColor : 'gray'}
          //leg shadow
          />
          <path className="cls-7" d="M496.46,987.07c-37.93-3.21-65.65-5.38-65.65-5.38l-25.66,3.39c1.46,9.12,3.27,18.34,5.48,27.31,5.09,20.58,10.43,48.84,15.83,77.06,19,4.2,44.46,10.1,72.28,16.48Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[6] ? selectedColor : 'gray'}
          />
          <path className="cls-2" d="M500.7,426.08s-1.25,53.69-18.7,64.75c16.83,4.2,69.17,3.92,74.15,0-14.95-8.21-18.69-71.05-18.69-71.05Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[7] ? selectedColor : 'white'}
          />
          <path className="cls-8" d="M537.46,419.78l-36.76,6.3a216.09,216.09,0,0,1-4.11,35.07,134.36,134.36,0,0,0,20.54,1.55,130.48,130.48,0,0,0,25.56-2.44A331.36,331.36,0,0,1,537.46,419.78Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[8] ? selectedColor : 'gray'}
          //neck shadow
          />
          <path className="cls-2" d="M582.84,385.16c0-43.31-29.5-91.9-65.89-91.9s-65.88,48.59-65.88,91.9,29.5,64.95,65.88,64.95S582.84,428.47,582.84,385.16Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[9] ? selectedColor : 'white'}
          />
          <path className="cls-7" d="M517,439.17c-34.87,0-63.4-19.9-65.71-59.69-.11,1.9-.17,3.8-.17,5.68,0,43.31,29.5,64.95,65.88,64.95s65.89-21.64,65.89-64.95c0-1.88-.06-3.78-.17-5.68C580.36,419.27,551.83,439.17,517,439.17Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[10] ? selectedColor : 'gray'}
          //face shadow
          />
          <path className="cls-5" d="M593.57,379.27c0-11.26-1.27-20.39-10.73-20.39S565.7,368,565.7,379.27s7.67,20.39,17.14,20.39S593.57,390.53,593.57,379.27Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[11] ? selectedColor : 'white'}
          />
          <path className="cls-9" d="M590,392.94a3.38,3.38,0,1,0-3.38,3.38A3.38,3.38,0,0,0,590,392.94Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[12] ? selectedColor : 'gray'}
          />
          <path className="cls-10" d="M593.57,390.25c-.49,0-.49,0-1,0a19.07,19.07,0,0,1-1.27,3.58,20.9,20.9,0,0,1,2.25-.2,27.27,27.27,0,1,1-7.44,1c3.1-2.18,1.44-4.11-.94-3.26a30.6,30.6,0,1,0,8.38-1.18Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[13] ? selectedColor : 'white'}
          />
          <path className="cls-5" d="M437.75,377.85c0-11.26,1.28-20.39,10.74-20.39s17.13,9.13,17.13,20.39-7.67,20.39-17.13,20.39S437.75,389.11,437.75,377.85Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[14] ? selectedColor : 'white'}
          />
          <path className="cls-9" d="M441.14,391.52a3.38,3.38,0,1,1,3.38,3.38A3.38,3.38,0,0,1,441.14,391.52Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[15] ? selectedColor : 'gray'}
          />
          <path className="cls-10" d="M437.59,388.83c.49,0,.49,0,1,0a19.81,19.81,0,0,0,1.27,3.58,20.71,20.71,0,0,0-2.24-.2,27.26,27.26,0,1,0,7.44,1c-3.11-2.18-1.44-4.11.94-3.26a30.6,30.6,0,1,1-8.38-1.18Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[16] ? selectedColor : 'white'}
          />
          <path className="cls-11" d="M517.91,407.29a1.59,1.59,0,0,1-.48-.07,18.38,18.38,0,0,0-2.07,0c-4.82.08-14.85.26-16.57-8.62-1.77-9.18,4.1-14.24,9.28-18.71.74-.64,1.47-1.27,2.17-1.9,3.15-2.86.25-15.23-2.8-23.1a1.75,1.75,0,1,1,3.27-1.27c7.84,20.19,2.95,26,1.89,27-.72.66-1.47,1.31-2.23,2-4.89,4.22-9.51,8.21-8.13,15.38,1.07,5.52,7.3,5.87,13.06,5.77a11.56,11.56,0,0,1,3.11.17,1.76,1.76,0,0,1-.5,3.44Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[17] ? selectedColor : 'black'}
          />
          <path className="cls-5" d="M527.2,345.76s-4.92,12.66,0,13.12,26.19-3.42,34.4,1.86C557.47,353.25,543.91,346,527.2,345.76Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[18] ? selectedColor : 'white'}
          />
          <path className="cls-12" d="M528.23,377.53a2.86,2.86,0,0,1,.24-.45,9.54,9.54,0,0,1,1-1.18,19,19,0,0,1,1.6-1.46c.64-.54,1.4-1.09,2.24-1.67s1.81-1.11,2.85-1.69a29.43,29.43,0,0,1,3.47-1.47,16.29,16.29,0,0,1,4.25-.81,14.05,14.05,0,0,1,4.5.87,24.93,24.93,0,0,1,3.8,1.73c1.18.65,2.31,1.31,3.35,2l2.94,2c.45.32.89.63,1.26.87l.26.16s0,0,0,0h-.15a1.23,1.23,0,0,0,.3,0,.93.93,0,0,0,.13,0,13.64,13.64,0,0,0,2.39-.57l2-.61,1.7-.55a.57.57,0,0,1,.52,1s-.54.4-1.52,1c-.49.31-1.09.69-1.82,1.09a15.66,15.66,0,0,1-2.65,1.2,4.87,4.87,0,0,1-.61.13l-.45,0h-.23l-.09,0-.2-.05-.37-.1-.45-.19c-.57-.24-1.07-.49-1.59-.75l-3.12-1.63c-1.08-.54-2.16-1.13-3.28-1.63s-2.26-1-3.37-1.36a10.18,10.18,0,0,0-3.14-.57,11.85,11.85,0,0,0-3.17.52,25.69,25.69,0,0,0-3.15,1c-1,.35-2,.73-2.84,1.1-1.77.71-3.22,1.38-4.22,1.86-.5.25-.86.45-1,.52a2.75,2.75,0,0,0-.36.27.56.56,0,1,1-.93-.64Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[19] ? selectedColor : 'black'}
          />
          <path className="cls-5" d="M493.42,345.76s4.92,12.66,0,13.12-26.18-3.42-34.4,1.86C463.15,353.25,476.71,346,493.42,345.76Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[20] ? selectedColor : 'white'}
          />
          <path className="cls-12" d="M488.94,378.17a2.24,2.24,0,0,0-.35-.27c-.18-.07-.55-.27-1-.52-1-.48-2.45-1.15-4.22-1.86-.87-.37-1.82-.75-2.84-1.1a25.69,25.69,0,0,0-3.15-1,11.79,11.79,0,0,0-3.17-.52,10.12,10.12,0,0,0-3.13.57c-1.12.36-2.25.87-3.37,1.36s-2.21,1.09-3.29,1.63l-3.12,1.63c-.52.26-1,.51-1.59.75l-.44.19-.38.1-.19.05-.1,0h-.23l-.45,0a5.29,5.29,0,0,1-.61-.13,16,16,0,0,1-2.65-1.2c-.72-.4-1.32-.78-1.82-1.09-1-.64-1.52-1-1.52-1a.57.57,0,0,1,.52-1l1.71.55,1.94.61a13.75,13.75,0,0,0,2.4.57c.1,0,.08,0,.12,0a1.33,1.33,0,0,0,.31,0h-.15s0,0,0,0l.26-.16c.37-.24.82-.55,1.26-.87l2.94-2c1.05-.69,2.17-1.35,3.35-2a25.84,25.84,0,0,1,3.8-1.73,14.1,14.1,0,0,1,4.5-.87,16.29,16.29,0,0,1,4.25.81,28.9,28.9,0,0,1,3.48,1.47c1,.58,2,1.12,2.85,1.69a27.51,27.51,0,0,1,2.23,1.67,19.31,19.31,0,0,1,1.61,1.46,8.59,8.59,0,0,1,1,1.18,2,2,0,0,1,.24.45.56.56,0,0,1-.14.79A.57.57,0,0,1,488.94,378.17Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[21] ? selectedColor : 'black'}
          />
          <path className="cls-10" d="M499.4,420.89s32.25,2.4,40.17-12.88C533.63,430.93,522.32,433.48,499.4,420.89Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[22] ? selectedColor : 'white'}
          />
          <path className="cls-3 grp" d="M449.29,351.63c6.22,3.35,4.14,18.82,16.33-5.87S468,312.4,487,316.17s17.58,3.4,32.08-3,26.53-4.52,29.07,4.15,4.41,16.4,13.45,17.12,6.88,1.7,11.9,11.34,1.88,16.78,14.25,11.7,2.84-42.8,2.84-42.8S567.16,286,555.75,285.24s-34.53.38-48.47,0-37.39,8-37.39,8l-18.82,10.09-7.5,27.15Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[23] ? selectedColor : 'gray'}

          //front hair
          />
          <path className="cls-2" d="M652.74,1075.75c0,2.49-259.22-16.82-264.2-21.18s-34.9-141.46,1.24-204.39c33.9-59,102.82-185.06,102.19-190-.35-2.78-21.9-43.11-39.11-79h0c-4.13-3.59-28.94-26.59-21.05-53.34.28-1,.61-1.94,1-2.92,10-5.09,49.22-34,49.22-34s37.39-5.69,74.15,0a91.82,91.82,0,0,1,11.75,4c-1-2-1.68-3.23-1.75-3.38.85.13,43,7.27,62.49,30.87.35,13.29-8,38.71-13.3,51.69,7.39,17.21,14.46,36,13.09,49.32-2.49,24.3-57.32,144.56-57.32,149.45S652.74,1073.25,652.74,1075.75Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[24] ? selectedColor : 'white'}
          />
          <path className="cls-13" d="M432.78,524.82c-.37,1-.7,1.95-1,2.92C431.75,526.19,432.06,525.19,432.78,524.82Z" transform="translate(-346.38 -252.3)"
          //nothing yet
          />
          <path className="cls-5" d="M482,490.83s9.34,67.25,48.89,67.25,33.91-59.84,19.77-75.88C530.09,483.2,482,490.83,482,490.83Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[25] ? selectedColor : 'white'}

          //neck lower
          />
          <path className="cls-4" d="M649,926.75c-.1.24-.2.51-.32.82l-.17-.82Z" transform="translate(-346.38 -252.3)"
          //nothing
          />
          <path className="cls-4" d="M650.27,926.75H649l.47-1.23Z" transform="translate(-346.38 -252.3)"
          //nothing
          />
          <path className="cls-6" d="M706.35,1367.93s11.94-19,13.22-18.58,24.73,17.12,20.89,18.58S706.35,1367.93,706.35,1367.93Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[26] ? selectedColor : 'black'}
          />
          <rect className="cls-2" x="184.87" y="278.78" width="12.4" height="834.65"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[27] ? selectedColor : 'white'}
          />
          <rect className="cls-2" x="158.91" y="196.73" width="64.33" height="95.32" rx="8.8"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[28] ? selectedColor : 'white'}
          />
          <rect className="cls-11" x="167.29" y="214.62" width="47.57" height="7.29"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[29] ? selectedColor : 'black'}
          />
          <rect className="cls-11" x="167.29" y="242.48" width="47.57" height="7.29"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[30] ? selectedColor : 'black'}
          />
          <rect className="cls-11" x="167.29" y="270.33" width="47.57" height="7.29"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[31] ? selectedColor : 'black'}
          />
          <path className="cls-2" d="M455.27,1368.58c0-4,36.79-7.22,82.18-7.22s82.17,3.23,82.17,7.22Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[32] ? selectedColor : 'white'}
          />
          <path className="cls-2" d="M552.74,618.11c-1.91-.32-24.08.92-25.4-2.71q-.06-.15-.12-.33c-4.5,10.89-109,95.75-177.71,79-15.41-97.4,83.27-169.27,83.27-169.27-11.61,30.4,20.64,56.75,20.64,56.75s-59.74,50.69-50.5,55.83c8.5,4.72,99.51-36.54,114.17-43.24.09-1.61,10.2-11,14.73-15.14a8.75,8.75,0,0,0,.46,2.92c-.68,1.95-1.5,4.28-2.34,6.62,4.55-2.24,9.44-4.34,12.27-4.62C548.59,583.31,554.66,618.43,552.74,618.11Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[33] ? selectedColor : 'white'}
          />
        </g>
        <g id="Layer_3" data-name="Layer 3">
          <path className="cls-14" d="M628.43,623.37c.87-8.45-1.66-19.09-5.5-30.12-2.33,20.2-7.17,41.5-17.21,52.3-19.82,21.3-75.33,23.1-75.33,23.1s19.4,1.61,35.75,18.65-3.58,75.88-23.44,83.1-67.45,10-67.45,10,73.32,18.5,80.9,30.87c7.17,11.68,58.23,193.34-167,243.56,14.31,4.82,263.63,23.35,263.63,20.91s-81.63-298-81.63-302.93S625.94,647.67,628.43,623.37Z" transform="translate(-346.38 -252.3)"
            onClick={handleClick}
            style={{ pointerEvents: 'all' }}
            fill={isClicked[34] ? selectedColor : 'gray'}
          />
        </g>
      </g>
    </svg>
  )
}

export default Temp8